module.exports = __webpack_public_path__ + "static/media/maintanance.70de5471.png";